<template>
  <div class="validation-modal-overlay">
    <div class="validation-modal">
      <div class="modal-header">
        <h2 class="title">
          {{ $t('components.dialogs.validation.title') }}
        </h2>
        <p class="subtitle">
          {{ $t('components.dialogs.validation.subtitle') }}
        </p>
      </div>

      <div class="modal-content">
        <div
          v-if="validationResult.length > 0"
          class="issues-list"
        >
          <div
            v-for="(offer, index) in validationResult"
            :key="index"
            class="issue-item"
          >
            <component
              :is="getIconByMaterialType(mountMaterial(offer.material_type), false)"
              class="material-type-img mr-4"
            />

            <div>
              <p class="offer-quantity">
                {{ $t('components.dialogs.validation.quantity', { quantity: offer.quantity }) }}
              </p>
              <p class="offer-uf">
                {{ $t('components.dialogs.validation.uf', { uf: offer.uf }) }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <rectoplus-button
          class="close-button"
          :text="$t('components.dialogs.validation.close')"
          @click="$emit('close')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import RectoplusButton from '@/components/buttons/RectoplusButton.vue';
import getIconsByMaterialType from '@/mixins/getIconsOfMaterialType';
import { MaterialType, MaterialTypeKey } from '@/enums/MaterialType';

export default {
  name: 'ValidationModal',
  components: {
    RectoplusButton,
  },
  mixins: [getIconsByMaterialType],
  props: {
    validationResult: {
      type: Array,
      required: true,
    },
  },
  methods: {
    mountMaterial(material) {
      switch (material) {
        case MaterialType.PAPER:
          return MaterialTypeKey.PAPER;
        case MaterialType.PLASTIC:
          return MaterialTypeKey.PLASTIC;
        case MaterialType.GLASS:
          return MaterialTypeKey.GLASS;
        default:
          return MaterialTypeKey.METAL;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.validation-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: $modal_overlay;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.validation-modal {
  background: $color_light;
  border-radius: 8px;
  padding: 20px;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 2px 10px $modal_shadow;

  .modal-header {
    margin-bottom: 20px;

    .title {
      margin: 0;
      font-weight: 600;
      text-align: center;
      font-size: 1.5em;
    }

    .subtitle {
      margin: 0;
      font-size: 1em;
      text-align: justify;
    }
  }

  .modal-content {
    margin-bottom: 20px;

    .issues-list {
      .issue-item {
        padding: 10px;
        margin-bottom: 10px;
        background-color: $modal_item_background;
        border-radius: 4px;
        display: flex;
        align-items: center;
        gap: 10px;
        font-weight: 600;

        .offer-quantity {
          margin: 0;
        }

        .offer-uf {
          margin: 0;
        }
      }
    }
  }

  .modal-footer {
    display: flex;
    justify-content: flex-end;

    .close-button {
      width: 100%;
    }
  }
}
</style>
